import styled from 'styled-components';

export const LoAHealthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
